module.exports = __webpack_public_path__ + "static/img/Tims.0d8dde4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/Tims.png
// module id = +lTO
// module chunks = 34